/**
 * Create date: 2024-05-09
 * Update date: 2024-08-30
 * Screen 2041.A
 */
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useState } from 'react';

const List = React.lazy(() => import('./List'));
const M2041ACreate = React.lazy(() => import('./CreateForm'));

// create context
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2041_AContext';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const M2041_A = () => {
  const { t }: any = useDictionary({ programId: '2041.A' });
  const [data, setData] = useState([]);
  const [formSearchData, setFormSearchData] = useState<any>({
    fromDate: new Date(),
    endDate: new Date(),
    dataList: {
      vendor: [],
    },
    vendor: '',
  });
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    formSearchData,
    setFormSearchData,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
        return <M2041ACreate />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2041_A;
